module.exports = __webpack_public_path__ + "assets/img/block-left-hover-c283ba13.png";